import React from 'react';

import PageHeader from './PageHeader.jsx';
import Utilities from '../utility/Utilities.jsx';

function withPageHandler(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.handlePageForItem = this.handlePageForItem.bind(this);
            this.handlePageHeader = this.handlePageHeader.bind(this);
        }

        _checkRenderOnlyFirst(d) {
            if (!d.props || !d.props.config) {
                return d;
            }
            const config = d.props.config.Config || d.props.config.config;
            if (!config || !config.Block || !config.Block.renderOnlyFirst) {
                return d;
            }
        }

        handlePageForItem(index, content, pageHeader, pageClassName) {
            if (this.props.builder) {
                return content;
            }
            let contentAfter = this.props.contentAfter;
            if (contentAfter && index > 0) {
                contentAfter = contentAfter.filter(this._checkRenderOnlyFirst);
            }
            let contentBefore = this.props.contentBefore;
            if (contentBefore && index > 0) {
                contentBefore = contentBefore.filter(this._checkRenderOnlyFirst);
            }
            let _pageClassName = 'pageContainer';
            if (pageClassName) {
                _pageClassName += ` ${pageClassName}`;
            }
            let style;
            if (this.props.onPageProps) {
                const pageProps = this.props.onPageProps();
                if (pageProps && pageProps.config && pageProps.config.Style) {
                    style = Utilities.Config.getStyle(pageProps.config.Style);
                }
            } else if (this.props.collateralConfig.Config && this.props.collateralConfig.Config.document && this.props.collateralConfig.Config.document.config && this.props.collateralConfig.Config.document.config.Style) {
                style = Utilities.Config.getStyle(this.props.collateralConfig.Config.document.config.Style)
            }
            let contentStyle;
            if (this.props.collateralType == 2 || this.props.collateralType == 3) {
                contentStyle = { verticalAlign: 'baseline' }
            }
            return (
                <table key={index} border="0" cellPadding="0" cellSpacing="0" className={_pageClassName} style={style} width="100%">
                    <tbody>
                        {
                            (this.props.forcePageHeader || index == 0 || this.props.collateralType == 1) &&
                            <tr className={this.props.preview ? 'pageHeader' : undefined}>
                                <td>{pageHeader}</td>
                            </tr>
                        }
                        {
                            contentBefore != undefined &&
                            contentBefore.length > 0 &&
                            <tr>
                                <td>
                                    {contentBefore}
                                </td>
                            </tr>
                        }
                        <tr>
                            <td style={contentStyle}>
                                {content}
                            </td>
                        </tr>
                        {
                            contentAfter != undefined &&
                            contentAfter.length > 0 &&
                            <tr>
                                <td>
                                    {contentAfter}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            );
        }

        handlePageHeader() {
            let pageHeader;
            if (this.props.collateralConfig) {
                pageHeader = <PageHeader {...this.props} contentConfig={this.props.collateralConfig} />
            }
            return pageHeader;
        }

        render() {
            return (
                <WrappedComponent {...this.props} onPageForItem={this.handlePageForItem} onPageHeader={this.handlePageHeader}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

export { withPageHandler };